import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import useBreakpoint from "utils/hooks/useBreakpoint";
import Mail from "components/icons/Mail";
import CallIcon from "components/icons/Call";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { track } from "utils/tracking";
import trackingEvents from "utils/trackingEvents";

const Card = styled.div``;

const IconContainer = styled.div.attrs({
  className:
    "flex justify-center items-center w-30-mattamy h-30-mattamy bg-mattamy-blue inline mr-2 rounded-full text-light-blue",
})`
  min-width: 1.875rem;
`;

const CallIconContainer = styled.div`
  min-width: 1.875rem;
`;

const ContactCard = ({ heading, shortDescription, emailAddress, phone }) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);

  return (
    <Card className="rounded mb-16 md:mb-20" isMobile={isMobile}>
      <h2 className="text-3xl text-mattamy-blue font-trade-gothic-20 leading-9 mb-1 tracking-tight">
        {heading}
      </h2>
      <p className="text-action-blue font-graphie tracking-tight leading-7 mb-5">
        <RichText
          tag="span"
          className="richtext"
          field={{ value: shortDescription }}
        />
      </p>
      <div className="flex flex-col h-full w-full font-graphie text-base text-mattamy-blue">
        {emailAddress && (
          <div className=" flex items-center">
            <IconContainer>
              <Mail className="h-4 w-4" />
            </IconContainer>
            <a
              className="break-all"
              href={`mailto:${emailAddress}`}
              onClick={() => {
                track({ eventId: trackingEvents.Email });
              }}
              aria-label={"Email to " + emailAddress}
            >
              {emailAddress}
            </a>
          </div>
        )}
        {phone && (
          <div className="mt-2 flex items-center">
            <CallIconContainer className="rounded-full mr-2">
              <CallIcon className="w-30-mattamy h-30-mattamy " />
            </CallIconContainer>
            <a
              className="break-all"
              href={`tel:${phone}`}
              onClick={() => {
                track({ eventId: trackingEvents.ClickToCall });
              }}
              aria-label={"Call to " + phone}
            >
              {phone}
            </a>
          </div>
        )}
      </div>
    </Card>
  );
};

ContactCard.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  email: PropTypes.string,
  phoneNumberCall: PropTypes.string,
  phoneNumberMessage: PropTypes.string,
};

export default ContactCard;
